import { Action } from '@ngrx/store';
import {DeviceGroupParam, Group} from '../../models/group';


export enum GroupActionTypes {
  GetGroups = '[Group] Get Groups',
  LoadGroups = '[Group] Load Groups',
  UpdateDeviceGroup = '[Group] Update Device Group',
  AddDeviceGroup = '[Group] Add Device Group',
  DeleteDeviceGroup = '[Group] Delete Device Group'
}

export class LoadGroups implements Action {
  readonly type = GroupActionTypes.LoadGroups;
  constructor(public payload: Group[] ) {}
}

export class GetGroups implements Action {
  readonly type = GroupActionTypes.GetGroups;
  constructor(public payload: any = null) {}
}

export class UpdateDeviceGroup implements  Action {
  readonly type = GroupActionTypes.UpdateDeviceGroup;
  constructor(public payload: DeviceGroupParam) {}
}

export class AddDeviceGroup implements  Action {
  readonly type = GroupActionTypes.AddDeviceGroup;
  constructor(public payload: DeviceGroupParam) {}
}

export class DeleteDeviceGroup implements  Action {
  readonly type = GroupActionTypes.DeleteDeviceGroup;
  constructor(public payload: DeviceGroupParam) {}
}

export type GroupActions = LoadGroups
  | GetGroups
  | UpdateDeviceGroup
  | AddDeviceGroup
  | DeleteDeviceGroup;
